import { styled } from "styled-components";
const CenteredPanelImpl = styled("div")(
  {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    margin: "0 auto"
  },
  ({ $centerY }) => $centerY ? {
    justifyContent: "center"
  } : void 0,
  ({ $maxWidth }) => ({ maxWidth: $maxWidth }),
  ({ $minWidth }) => ({ minWidth: $minWidth })
);
export {
  CenteredPanelImpl
};
